module.exports = __webpack_public_path__ + "img/credit-card-shield.b29c4c00.svg";